module.exports = __webpack_public_path__ + "static/media/spotify-icon.0be66e21.png";